export default "__VITE_ASSET__CfZ1COt8__"